<template>
  <div>
    <b-container>
      <div style="position: sticky;top: 0;background-color: #fff;z-index: 9;border-bottom: 1px solid #e7e7e7;">
        <navbar></navbar>
      </div>
      <b-row>
        <!-- 左边 -->
        <b-col cols="8">
          <!-- 公告 -->
          <!-- 列表 -->
          <div style="margin-top: 36px;" v-if="fenye.hasOwnProperty('data')">
            <normalList :list="fenye.data"></normalList>
          </div>
          <div class="mt-3" style="display: flex;justify-content: center;" v-if="fenye.hasOwnProperty('current_page')">
            <el-pagination layout="prev, pager, next" :total="fenye.total" @current-change="changeYe">
            </el-pagination>
          </div>
        </b-col>
        <!-- 右边 -->
        <b-col cols="4">
          <userBox></userBox>
          <!-- <rebang></rebang> -->
          <hotVideo :list="remen"></hotVideo>
        </b-col>
      </b-row>
      <qFooter></qFooter>
    </b-container>
  </div>
</template>
<script>
  import navbar from "../components/navbar/navbar.vue"
  import qFooter from "../components/footer/footer.vue"
  import userBox from "../components/userBox/userBox.vue"
  import normalList from "../components/normalList/normalList.vue"
  import rebang from "../components/rebang/rebang.vue"
  import hotVideo from "../components/hotVideo/hotVideo.vue"
  import {
    mapActions,
    mapGetters
  } from 'vuex'
  import {
    getNotice,
    tuijian,
    liebiao
  } from '../api/api.js'
  export default {
    computed: {
      ...mapGetters(['userInfo'])
    },
    components: {
      navbar,
      qFooter,
      userBox,
      normalList,
      rebang,
      hotVideo
    },
    data() {
      return {
        fenye: {},
        page: 1,
        remen: null
      }
    },
    created() {
      this.getNoticeIndex()
      this.getLiebiao()
    },
    methods: {
      changeYe(e) {
        console.log(e);
        this.page = e
        this.getLiebiao()
      },
      getNoticeIndex() {
        //获取公告
        getNotice({
          page: 1
        }).then(res => {
          console.log(res);
          this.noticeList = res.data.data
        })
      },
      getLiebiao() {
        //获取戏曲列表
        let that = this
        liebiao({
          type: 1,
          page: this.page
        }).then(res => {
          that.fenye = res.data.data
          that.fenye.current_page = that.page
          this.$forceUpdate()
          let randomNumber = Math.floor(Math.random() * (that.fenye.data.length))
          console.log(randomNumber);
          this.getTuijian(that.fenye.data[randomNumber].id)
        })
      },
      getTuijian(id) {
        //获取推荐
        tuijian({
          id,
        }).then(res => {
          console.log(res);
          this.remen = res.data.data.data
        })
      }
    }
  }
</script>
<style>
  .noticeItem:hover {
    color: red;
    user-select: text;
    cursor: pointer;
  }

  .needHover:hover {
    color: red;
    cursor: pointer;
  }

  .noticeItem {
    margin: 10px 0;
    user-select: none;
  }

  .active {
    color: #FFC107 !important;
  }
</style>


// WEBPACK FOOTER //
// src/view/hello.vue